import React, { useState } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { SowillKeyResponseModel } from '@/domain/models'
import { useMediaQueries } from '@/presentation/hooks'
import { Box, Select } from '@/presentation/components'
import { selectSowillKeyState } from './atom'
import { sowillKeysState } from '../atom'

type SelectSowillKeyProps = {
  disabled?: boolean
}

export const SelectSowillKey: React.FC<SelectSowillKeyProps> = ({ disabled }) => {
  const keys = useRecoilValue(sowillKeysState)
  const [isMenuOpen, setMenuOpen] = useState(false)
  const [key, setKey] = useRecoilState(selectSowillKeyState)
  const { isMobile } = useMediaQueries()

  const handleSelectCompany = (identifier: SowillKeyResponseModel): void => {
    const { codCliente, ...key } = identifier
    setKey(key)
    setMenuOpen(false)
  }
  const handleOpen = (): void => {
    if (!disabled) {
      setMenuOpen(true)
    }
  }

  const getDescription = (): string => {
    if (!key.chave) return 'Selecione o identificador'

    return `Empresa ${key.empresaMonitoramento} - Chave ${key.chave}/${key.particao}`
  }

  const customStyle = (): object => {
    if (isMobile) {
      return {
        margin: 'auto'
      }
    } else {
      return {
        marginLeft: 'auto'
      }
    }
  }

  return (
    <Box style={customStyle()}>
      <Select.Trigger
        label='Identificador SoWill'
        description={getDescription()}
        disabled={disabled}
        onOpen={handleOpen}
      />
      <Select.Modal
        title='Selecione o identificador'
        isOpen={isMenuOpen}
        onClose={() => setMenuOpen(false)}
        items={keys.map((identifier, index) => ({
          id: index,
          descricao: `Empresa ${identifier.empresaMonitoramento} - Chave ${identifier.chave}/${identifier.particao}`,
          data: identifier,
          isSelected:
            identifier.empresaMonitoramento === key.empresaMonitoramento &&
            identifier.chave === key.chave &&
            identifier.particao === key.particao
        }))}
        onSelect={(_, identifier) => handleSelectCompany(identifier)}
      />
    </Box>
  )
}
